import { useState } from "react";

import { Button, Divider, Grid, Link, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { filter } from "lodash";
import { CSVLink } from "react-csv";

import useApp, { ProductLevel } from "hooks/useApp";
import { colors } from "theme";
import {
  IAssignedUser,
  UserRole,
  UserRoleFilter,
  UserStatus,
} from "types/user";

const useStyles = makeStyles((theme: Theme) => ({
  leftContent: {
    width: "auto",
    "& > button": {
      fontFamily: theme.typography.fontFamily,
      color: colors.nero[300],
      padding: "0 6px",
      fontSize: 14,
      lineHeight: "22px",
      letterSpacing: 0.5,
      "&:hover": { color: theme.palette.primary.main },
    },
  },
  filterDivider: {
    backgroundColor: colors.nero[300],
    height: 15,
  },
  activeFilter: {
    color: `${theme.palette.primary.main} !important`,
  },
}));

export const FilterGroup = ({
  activeFilter,
  data,
  setActiveFilter,
}: {
  activeFilter: UserRoleFilter;
  data: IAssignedUser[];
  setActiveFilter: Function;
}) => {
  const classes = useStyles();
  const { productLevel } = useApp();
  const [exportData, setExportData] = useState<any>([]);

  return (
    <Grid container justifyContent="space-between">
      <Grid item container alignItems="center" className={classes.leftContent}>
        {productLevel !== ProductLevel.MVP && (
          <>
            <Link
              component="button"
              onClick={() => setActiveFilter(UserRoleFilter.All)}
              className={`${
                activeFilter === UserRoleFilter.All ? classes.activeFilter : ""
              }`}
            >
              All [{data.length}]
            </Link>
            <Divider orientation="vertical" className={classes.filterDivider} />
            <Link
              component="button"
              onClick={() => setActiveFilter(UserRoleFilter.Customer)}
              className={`${
                activeFilter === UserRoleFilter.Customer
                  ? classes.activeFilter
                  : ""
              }`}
            >
              Customer [
              {filter(data, (item) => item.role === UserRole.Customer).length}]
            </Link>
          </>
        )}
      </Grid>
      <Grid item>
        <CSVLink
          headers={[
            { label: "ID", key: "id" },
            { label: "Status", key: "status" },
            { label: "Name", key: "name" },
            { label: "Email", key: "email" },
            { label: "Role", key: "role" },
            { label: "Created", key: "created" },
            { label: "Updated", key: "updated" },
          ]}
          data={exportData}
          onClick={() => {
            setExportData(
              data.map((user) => ({
                id: user.id,
                status: UserStatus[user.status],
                name: `${user.firstName} ${user.lastName}`,
                email: user.email,
                role: user.role,
                created: user.created,
                updated: user.updated,
              }))
            );
          }}
          filename="users.csv"
          style={{ textDecoration: "none" }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="small"
            style={{ textTransform: "none" }}
          >
            Export CSV
          </Button>
        </CSVLink>
      </Grid>
    </Grid>
  );
};
